import { Component, Inject, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { consts } from '@src/constants/consts';
import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';

import * as _ from 'lodash';
import $ from 'jquery';

@Component({
    selector: 'policy-management',
    template: require('./policy-management.component.html'),
    styles: [require('./policy-management.component.scss')]
})
export class PolicyManagementComponent implements OnInit, OnDestroy {
    public processData: any;
    public selectedItem: any;
    public indexInList: any;

    private getPolicyFlag = false;
    private unsubscribe: any;
    private onDeleteFlag: any;
    private policiesServerToClient: any;
    private policyServerToClient: any;

    constructor(
        private store: Store,
        @Inject('$filter') $filter: any,
        private dialogManagerService: DialogManagerService) {
        this.policiesServerToClient = $filter('policiesServerToClient');
        this.policyServerToClient = $filter('policyServerToClient');
        this.unsubscribe = this.store.subscribe(() => {
            if (this.getPolicyFlag) {
                this.getPolicyFlag = false;
                return;
            }
            if (this.onDeleteFlag) {
                this.onDeleteFlag = false;
            } else {
                const policyEngine = this.store.getState().policyEngine;
                if (policyEngine.policies_meta_data) {
                    this.processData = this.policiesServerToClient(
                        policyEngine.policies, policyEngine.categoriesWithRule, policyEngine.policies_meta_data)[0];
                    this.processData.policies = policyEngine.policies;
                    this.processData.MetaData.envTypes = this.processData.MetaData.envTypes
                        .filter((x: any) => x.Key !== consts.envTypes.PreRun);
                }
            }
        });
    }

    public async ngOnInit() {
        await this.store.dispatch({ type: policyEngineActions.GET_POLICIES_ENUMS });
        await this.store.dispatch({ type: policyEngineActions.GET_POLICIES });
    }

    public ngOnDestroy() {
        this.unsubscribe();
    }

    public async getPolicy(selectedItem: any, indexInList: any) {
        if (selectedItem && !selectedItem.isNew) {
            this.getPolicyFlag = true;
            const { data } = await this.store.dispatch({
                type: policyEngineActions.GET_POLICIE_DETAILS,
                payload: { policyId: selectedItem.id }
            });
            if (data) {
                const processDataPolicy = this.policyServerToClient(
                    data, this.store.getState().policyEngine.policies_meta_data)[0];
                this.selectedItem = processDataPolicy;
                this.getPolicyFlag = false;
            }
        } else if (selectedItem.isNew) {
            this.selectedItem = selectedItem;
        }
        this.indexInList = indexInList;
    }

    public async addPolicy() {
        let newPolicy: any = {};
        this.getPolicyFlag = true;
        const { data } = await this.store.dispatch({
            type: policyEngineActions.GET_POLICIE_DETAILS,
            payload: { policyId: 0 /*fake policy*/ }
        });
        if (data) {
            newPolicy = this.policyServerToClient(data, this.store.getState().policyEngine.policies_meta_data)[0];
            this.getPolicyFlag = false;
            newPolicy.id = 0;
            newPolicy.name = 'New Policy';
            newPolicy.isNew = true;
            newPolicy.description = '';
            newPolicy.relationship = { key: true, value: 'Or' };
            newPolicy.environmentTypes = this.processData.MetaData.envTypes;
            newPolicy.dbs = this.processData.MetaData.dbTypes;
            newPolicy.action = this.preSelectedAction(this.processData.MetaData.actions, 'Block');

            if (!this.locateExistingNewPolicy()) {
                this.selectedItem = this.deepCopy(newPolicy);
                this.indexInList = 0;
                this.processData.policies = [newPolicy, ...this.processData.policies];
            }

            setTimeout(() => { $('ul.dbm-list > li:first-child').click(); }, 50);
        }
    }

    private preSelectedAction(actions: any, findBy): number[] {
        const value = actions.find(o => o.Value === findBy);
        return value ? [value.Key] : [];
    }

    private locateExistingNewPolicy() {
        const newPolicy = _.find(this.processData.policies, (policy: any) => policy.isNew);
        return newPolicy;
    }

    public async onDuplicatePolicy(data: any) {
        await this.store.dispatch({
            type: policyEngineActions.DUPLICATE_POLICY,
            payload: { policyDataId: data.id }
        });
        await this.store.dispatch({ type: policyEngineActions.GET_POLICIES });
    }

    public onDeletePolicy() {
        if (this.selectedItem) {
            const onConfirm = () => {
                this.onDeleteFlag = true;
                if (this.locateExistingNewPolicy()) {
                    this.processData.policies.splice(0, 1);
                    this.selectedItem = this.processData.policies[0];
                    this.indexInList = 0;
                } else {
                    const policy = this.processData.policies[this.indexInList];
                    this.store.dispatch({
                        type: policyEngineActions.DELETE_POLICY,
                        payload: { policyId: policy.id }
                    }).then((response: any) => {
                        if (response && !response.status) {
                            this.processData.policies.splice(this.indexInList, 1);
                            this.selectedItem = this.processData.policies[0];
                            this.indexInList = 0;
                            this.store.dispatch({ type: policyEngineActions.GET_POLICIES });
                        }
                    });
                }
            };
            const itemName = this.processData.policies[this.indexInList].name;
            const dialogData = { title: 'Delete Policy', action: 'delete', objectType: 'policy', item: itemName };
            this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
        }
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-management/policy-management.component.ts